export default {
  /* 신규 번역 */
  'u.header.exchange': 'Exchange',
  'u.header.myinvest': 'Investment',
  'u.header.wallet': 'Wallet',
  'u.header.mypage': 'My page',
  'u.header.cscenter': 'Customer service',
  'u.header.login': 'Login',
  'u.header.logout': 'Log out',
  'u.header.signup': 'Create account',
  'u.header.hello_message': 'Hello, <span class="name">{name}</span>',

  'u.login.login': 'Login',
  'u.login.email': 'Email',
  'u.login.password': 'Password',
  'u.login.check_exchange_address':
    'Please check that you are visiting website that address is same as below.',
  'u.login.please_proceed_recaptcha': 'Please proceed CAPTCHA verification.',
  'u.login.alert.please_enter_email': 'Please enter email.',
  'u.login.alert.invalid_email': 'Invaild Email address.',
  'u.login.alert.please_enter_password': 'Please enter password.',

  'u.mypage.kyc_verification': 'KYC Authentication',
  'u.mypage.kyc.verification_type': 'Type of identification',
  'u.mypage.kyc.passport': 'Passport',
  'u.mypage.kyc.id_card': 'ID Card',
  'u.mypage.kyc.driver_card': 'Drive card',
  'u.mypage.kyc.name': 'name',
  'u.mypage.kyc.first_name': 'First name',
  'u.mypage.kyc.last_name': 'Last name',
  'u.mypage.kyc.select': 'Select',
  'u.mypage.kyc.mobile_number': 'Mobile(Only Number)',
  'u.mypage.kyc.passport_number': 'Passport Number',
  'u.mypage.kyc.id_card_number': 'ID Number',
  'u.mypage.kyc.driver_card_number': 'Drive License Number',
  'u.mypage.kyc.region': 'Documents issued by country / region',
  'u.mypage.kyc.expire_date': 'Expiration Date',
  'u.mypage.kyc.issue_date': 'Issued Date',
  'u.mypage.kyc.upload_image': 'Upload',
  'u.mypage.kyc.upload': 'Upload',
  'u.mypage.kyc.modify': 'Modify',
  'u.mypage.kyc.delete': 'Delete',
  'u.mypage.kyc.country': 'Country',
  'u.mypage.kyc.city': 'City',
  'u.mypage.kyc.address': 'Address',
  'u.mypage.kyc.postcode': 'Postcode',
  'u.mypage.kyc.upload_image_example': 'Upload Image Example',
  'u.mypage.kyc.upload_image_example_description':
    'You can choose to upload the front of your Driver’s License or your National ID Doucument, together with a Note. Please provide a photo of you holding your Identity card. In the same picture, make a reference to “Maju.com” and today’s date displayed. Make sure your face is clearly visible and that all Identity card detail are clearly readable.',
  'u.mypage.kyc.ok': 'OK',
  'u.mypage.kyc.please_upload_file_size_below_5mb':
    'Please upload your file size below 5MB.',
  'u.mypage.kyc.please_hide_some_number':
    'When uploading a certified photo, be sure to cover the number as a sample photo!',

  /* register otp modal */
  'u.mypage.otp.email': 'Email',
  'u.mypage.otp.password': 'Password',
  'u.mypage.otp.otpcode': 'OTP Code',
  'u.mypage.otp.otp_activate': 'Activate OTP',
  'u.mypage.otp.i_check_about_otp': 'I checked.',
  'u.mypage.otp.otp_warning_li1':
    'Please scan the left QR code with your mobile phone.',
  'u.mypage.otp.otp_warning_li2':
    'This code will change when OTP is initialized.',
  'u.mypage.otp.otp_warning_li3':
    'Not available if you delete this QR code from your mobile phone',
  'u.mypage.otp.alert.otp_warning_check':
    'Please read and check the precautions.',
  'u.mypage.otp.alert.otp_activation_completed': 'OTP setup completed.',

  hello: 'Hello',
  coin_search_placeholder: 'Coin name/Search',
  coin_name: 'Coin name',
  coin_list_loading: 'Loading.',
  There_is_no_coin: 'No match.',
  now_price: 'Current price',
  compare_yesterday: 'YTD',
  trade_volume: '24H Vol',
  my_balances: 'My asset',
  holding_coin: 'Holding',
  total_balances_cash: 'Holding UP',
  total_balances: 'Total asset',
  total_buying: 'Total PUR',
  total_valuation: 'Total EVAL',
  profit_amount: 'VAL G&L ',
  profit_rate: 'Profit rate',
  notice: 'Notice',
  notice_short: 'Notice',
  notice_loading: 'Loading.',
  There_is_no_notice: 'There is nothing on this page',
  company: 'INTRO ',
  guide: 'Guide',
  terms: 'User agreement',
  privacy: 'Privacy policy',
  kakaotalk: 'Contact by Kakaotalk (24H)',
  account_support: 'A/C, Contact us',
  wallet_support: 'Wallet, Q&A',
  'common.loading': 'Loading...',
  'common.please_login': 'Please <span class="name">Login</span>.',
  'common.empty': 'There is nothing on this page.',
  'common.million': 'M',
  'menu.exchange': 'Exchange',
  'menu.myinvest': 'Investment',
  'menu.wallet': 'Wallet',
  'menu.mypage': 'My page',
  'menu.cscenter': 'Customer service',
  'menu.login': 'Login',
  'menu.logout': 'Log out',
  'menu.signup': 'Create account',
  'menu.iex_announcement': 'IEX Announcement',
  'main.banner.phrase1': 'meet brand new IEX GLOBAL!',
  'main.banner.phrase2':
    'IEX GLOBAL EXCH provides the best user UX for crytocurrency exchange.',
  'main.banner.phrase3':
    'As an overseas IEX partner, it is the first gloval exchnage that runs IEX exchange over the world such as China, Thailand, Vietnam, Indonesia, etc. <br />.',
  'main.notice': 'Notice',
  'main.is_logged_in': 'Signed in.',
  'main.no_notice': 'There is nothing on the notice.',
  'main.uio_explain':
    'Offer IEXCO mining coin depending on the exchange amount!',
  'main.contribute_cash_explain':
    'Provide IEXCO CASH depending on the contribution!',
  'main.cash_can_be_charged_with_platform':
    'Cryptocurrency can be purchsed using cash from affiliate platform and cash can also be used at affiliate platform.',
  'main.platform_point_to_cash': 'convert to cash through affiliate platform',
  'main.uioex_wallet': 'CRYPTO IEX Wallet',
  'main.uioex_exchange': 'IEX CRYPTO EXCH',
  'main.uioex_features': 'IEX FEAT.',
  'main.transparency': 'Transparency',
  'main.transparency_explain':
    'Above 90% of cryptocurrency is stored in Cold Storage',
  'main.cs24': '24H customer service',
  'main.cs24_explain':
    'Through 24hours online help service, we can help you solve your issue.',
  'main.security': 'Safe security',
  'main.security_explain':
    'Three levels security system that of perfectly secured financial organizations are established through partnership with the best domestic security compnay S1',
  'main.giving_uio': 'Provide IEXCO coin',
  'main.giving_uio_explain':
    'Depending on exchange trade performance, IEXCO coin will be compensated.',
  'main.with_shoppingmall': 'Linked with shopping mall',
  'main.with_shoppingmall_explain':
    'Holding cash can freely transfer within affiliate platfrom (shopping mall) using transfer function.',
  'main.mobile_feature_title': 'Optimized service for mobile trade',
  'main.mobile_feature_01':
    'Provide mobile specialized UI that can be used anytime, anywhere',
  'main.mobile_feature_02':
    'Exchange affiliate platform coin wallet address linked with cell phone no.',
  'main.mobile_feature_03': 'Provide app for Android & iOS(Open Soon)',
  'main.go_to_exchange': 'View EXCH',
  'main.cash_market': 'UP market',
  'trade.order': 'Order',
  'trade.orderbook': 'Orderbook',
  'trade.marketprice': 'Market price',
  'trade.chart': 'Chart',
  'trade.info': 'info.',
  'trade.now_price': 'Current price',
  'trade.evaluated_price': 'EVAL price',
  'trade.change': 'YTD',
  'trade.volume': 'Vol',
  'trade.yesterday_last_price': 'YTD last price',
  'trade.today_high': 'High',
  'trade.today_low': 'Low',
  'trade.volume_fiat': 'Trade Vol.',
  'trade.high': 'High',
  'trade.low': 'Low',
  'trade.holding_coin': 'Holding coin',
  'trade.coin_name': 'Coin name',
  'trade.holding_amount': 'Holding Qty',
  'trade.evaluted_price': 'EVAL price',
  'trade.coin_info': 'Coin Info.',
  'trade.yesterday_contribution_cash': 'YTD contrib. cash',
  'trade.yesterday_contribution_cash_trade': 'trade',
  'trade.yesterday_contribution_cash_not_trade': 'INC TRD',
  'trade.paid_contribution_cash': 'Contrib. cash paid',
  'trade.person_count': 'No.',
  'trade.holding_uio_coin': 'Holding IEXCO coin (avg.)',
  'trade.recommender_count': 'Followers',
  'trade.recommender_volume_fiat': 'Recommender trade Qty.',
  'trade.type': 'Type',
  'trade.gubun': 'Type',
  'trade.time': 'Time',
  'trade.ordered_time': 'Confirmed time',
  'trade.price': 'Price',
  'trade.amount': 'Qty.',
  'trade.ordered_amount': 'Ordered Qty.',
  'trade.ordered_price': 'Ordered price',
  'trade.cancel_select': 'CXL selected order',
  'trade.outstanding_amount': 'Unconfirmed Qty.',
  'trade.confirmed_price_short': 'Price',
  'trade.confirmed_price': 'Confirmed Qty.',
  'trade.confirmed_amount': 'Confirmed Qty.',
  'trade.confirmed_amount_cash': 'Price',
  'trade.confirmed_time': 'Confirmed time',
  'trade.status': 'Status',
  'trade.all': 'All',
  'trade.confirming': 'Confirming',
  'trade.completed': 'Completed',
  'trade.cancel': 'Cancel',
  'trade.buy': 'Buy',
  'trade.sell': 'Sell',
  'trade.realtime_trade_history': 'Confirmed RT',
  'trade.outstanding_order': 'Unconfirmed',
  'trade.confirmed_order': 'Confirmed',
  'trade.order_amount': 'Order Qty.',
  'trade.orderbook_price': 'Asking price',
  'trade.cancel_all': 'Cancel All',
  'trade.orderbook_left_amount_sum': 'Remaining Sum',
  'trade.orderable': 'Order AVAIL',
  'trade.buy_amount': 'AMT of purchase',
  'trade.buy_price': 'PUR. price',
  'trade.sell_amount': 'Sale AMT',
  'trade.sell_price': 'Selling price',
  'trade.charge_cash': 'Charge',
  'trade.compare_with_now_price': ' % compared to CMP',
  'trade.total_order_price': 'Total AMT',
  'trade.max': 'MAX',
  'trade.can': 'AVAIL.',
  'trade.min_order_amount_price': 'Min. order price',
  'trade.reset': 'Reset',
  'trade.fee': 'Fee',
  'trade.today_total_volume': 'Total vol.',
  'trade.yesterday_uio_mining': 'YTD IEXCO coin mining',
  'trade.today_minable_amount': 'Daily mined AMT.',
  'trade.today_minable_bonus_amount': "Today's mined bonus AMT.",
  'trade.total_volume': 'Total trade',
  'trade.my_volume': 'My trade',
  'trade.holding_uio_amount_avg': 'Holding IEXCO amount (avg.)',
  'trade.mined_uio_amount': 'IEXCO mined amount',
  'trade.recieved_bonus_uio_amount': 'Provided IEXCO bonus',
  'trade.total_mined_uio_amount': 'Total IEXCO mined Qty.',
  'trade.there_is_no_outstanding_orders': 'There is no unconfirmed order.',
  'trade.there_is_no_closed_orders': 'There is no confirmed order.',
  'myinvest.funds': 'Asset history',
  'myinvest.trade_history': 'Trade history',
  'myinvest.outstanding_order': 'Unconfirmed trade history',
  'myinvest.wait_deposit_and_withdraw': 'D/W pending',
  'myinvest.myinvest_info':
    '* ASP, EVAL price, VAL G&L , profit rate is REF. which is estimated value converted to CASH.',
  'myinvest.total_buy': 'Total PUR price',
  'myinvest.total_evaluate': 'Total EVAL price',
  'myinvest.total_profit': 'total VAL G&L ',
  'myinvest.total_profit_rate': 'Total profit rate',
  'myinvest.holding_cash': 'Holding UP',
  'myinvest.holding_total_assets': 'Total asset',
  'myinvest.holding_total_coin': 'Total coin',
  'myinvest.coin_name': 'Coin name',
  'myinvest.holding_amount': 'Holding Qty.',
  'myinvest.buy_unit_price_avg': 'ASP',
  'myinvest.buy_price': 'PUR price',
  'myinvest.evaluated_price': 'EVAL price',
  'myinvest.evaluated_profit_rate': 'VAL G&L (%)',
  'myinvest.order': 'Order',
  'myinvest.coin': 'Coin',
  'myinvest.confirmed_time': 'Confirmed time',
  'myinvest.order_price': 'Order price',
  'myinvest.confirmed_amount': 'Final Qty',
  'myinvest.fee': 'Fee',
  'myinvest.confirmed_price_avg': 'Confirmed price (avg.)',
  'myinvest.confirmed_amount_price': 'Total price',
  'myinvest.7d': '7d',
  'myinvest.30d': '30d',
  'myinvest.90d': '90d',
  'myinvest.search': 'Search',
  'myinvest.order_time': 'Order time',
  'myinvest.order_amount': 'Order Qty.',
  'myinvest.outstanding_amount': 'Unconfirmed Qty.',
  'myinvest.etc': 'Note',
  'myinvest.time': 'Time',
  'myinvest.amount': 'Price/AMT.',
  'myinvest.platform': 'Platform',
  'myinvest.deposit_name': 'Payer',
  'myinvest.status': 'Status',
  'myinvest.go_to_block_explorer': 'Log',
  'myinvest.txid': 'txid',
  'myinvest.deposit_wait': 'Deposit pending',
  'mypage.member_info': 'Member info.',
  'mypage.security': 'Security VER.',
  'mypage.connection_info': 'Connection info.',
  'mypage.contribution_cash_title': 'Contrib. UP payment history',
  'mypage.contribution_cash_title_short': 'Contrib. cash',
  'mypage.uio_mining': 'IEXCO coin mining history',
  'mypage.uio_mining_short': 'Mining history',
  'mypage.recommender': 'Recommender',
  'mypage.change_password': 'Change pw.',
  'mypage.email': 'Email',
  'mypage.name': 'Name',
  'mypage.phone': 'Mobile',
  'mypage.security_level': 'Security Lv.',
  'mypage.your_trading_fee': 'Your trade fee (VAT inc.)',
  'mypage.cash_markets': 'UP market',
  'mypage.event_alram': 'Receive info. (email, SMS) on event, etc.',
  'mypage.event_alram_ok_or_deny': 'Event notification setting / Deny',
  'mypage.event_alram_explain':
    '※ Important notice on deposit and withdrawal will be sent as an email regardless of event notification setting.',
  'mypage.password_condition':
    'The password needs to be at least 8 characters with lower case, number, and special character',
  'mypage.now_password': 'Current pw.',
  'mypage.new_password': 'New pw.',
  'mypage.new_password_check': 'Check new pw.',
  'mypage.level': 'Lv.',
  'mypage.your_level':
    "<span class='name'>{name}</span>'s current security level is <span class='level'>{level}</span>.",
  'mypage.your_level_description':
    'Your current membership is [level {level}], so you can use the exchange immediately.',
  'mypage.next_level_can_easy_deposit':
    'By using next level D/Wal account verification, quick D/Wal service is available.',
  'mypage.email_verification': 'Email VER.',
  'mypage.phone_verification': 'Mobile VER.',
  'mypage.bank_verification': 'A/C VER.',
  'mypage.otp_verification': 'OTP VER.',
  'mypage.optional': 'Option',
  'mypage.otp_app_desc':
    'You need to install Google Authenticator App for smartphone (Android, iOS).',
  'mypage.otp_is_optional': '*OTP verification is optional.',
  'mypage.set': 'Set',
  'mypage.request_reset': 'Request reset',
  'mypage.verify': 'Verify',
  'mypage.deposit_info': 'A/C info. for deposit',
  'mypage.withdraw_info': 'A/C info. for withdrawal',
  'mypage.bank_name': 'Bank name',
  'mypage.bank_account': 'A/C no.',
  'mypage.bank_account_holder': 'A/C holder',
  'mypage.deposit': 'Deposit',
  'mypage.request_change_bank_account': 'Request change',
  'mypage.realname_account_check': 'A/C VER. service using name',
  'mypage.select_bank': 'Select bank',
  'mypage.bank_account_placeholder': "Enter the number without '-'.",
  'mypage.not_this_bank': 'Cannot be used in NH&CH',
  'mypage.verify_my_account': 'Verify my A/C',
  'mypage.otp_setting': 'OTP setting',
  'mypage.otp_code_setting': ' OTP code setting',
  'mypage.otp_with_login': 'Login (Show OTP verification during login)',
  'mypage.otp_with_withdraw': 'Withdrawal (Show OTP verification during capital transfer)',
  'mypage.verification_code': 'VER no.',
  'mypage.email_verification_code': 'E-mail Auth Number',
  'mypage.please_input_otp_verification_code': 'Enter OTP verification no.',
  'mypage.save': 'Save',
  'mypage.otp_setting_alert':
    '※ If you want to change the setting, please diseanble the check box.',
  'mypage.otp_delete': 'Disenable OTP setting',
  'mypage.otp_delete_alert':
    "※ Once you disenable the setting, OTP setting will be reset. Therefore, existing OTP won't be valid and you need to register new OTP.",
  'mypage.connection_info_desc':
    'The following is your login history. If there is a history that you have not logged in, please log out from all devices and chage to secret no.',
  'mypage.location': 'Location',
  'mypage.device': 'Device',
  'mypage.browser': 'Browser',
  'mypage.ip': 'IP',
  'mypage.date': 'Date',
  'mypage.contribution_cash_date': 'Date',
  'mypage.holding_coin': 'Holding coin',
  'mypage.holding_coin_state': 'Holding coin',
  'mypage.volume': 'Trade vol',
  'mypage.recommender_count': '# of recommender',
  'mypage.recommender_volume': 'Trade vol. by recommender',
  'mypage.contribution_cash': 'Contrib. UP',
  'mypage.day': 'dd',
  'mypage.month': 'mm',
  'mypage.year': 'yy',
  'mypage.accumulated_contribution_cash': 'ACC. Contrib. cash',
  'mypage.date_range': 'Period',
  'mypage.search': 'Search',
  'mypage.accumulated_uio_mining': 'ACC. mined coin',
  'mypage.for_mining_volume': 'My trade VOL.',
  'mypage.mined_amount': 'Mined Qty.',
  'mypage.bonus_uio_mined_amount': 'IEXCO bonus Qty.',
  'mypage.total_uio_mined_amount': 'Total IEXCO mined Qty.',
  'mypage.mined_unit_price': 'Mining unit price',
  'mypage.mined_uio': 'IEXCO mined Qty.',
  'mypage.no': 'No',
  'mypage.recommend_date': 'Recommended date',
  'mypage.more_withdraw_limit': 'More Withdraw Limit',
  'support.notice': 'Notice',
  'support.guide': 'User guide',
  'support.faq': 'FAQ',
  'support.document_guide': 'Guide to document submission',
  'support.inquiry': '1:1 Inquiry',
  'support.notice_all': 'All',
  'support.notice_title': 'Title',
  'support.notice_content': 'Content',
  'support.notice_date': 'Registered date',
  'support.search': 'Search',
  'support.no': 'No',
  'wallet.total_assets': 'Total assets',
  'wallet.cash_plus_coin': '(USDT+CRYPTO EVAL Qty.)',
  'wallet.evaluated_coin': 'CRYPTO EVAL Qty.',
  'wallet.evaluated_profit': 'VAL G&L ',
  'wallet.evaluated_profit_rate': 'Profit rate',
  'wallet.coin_name': 'Coin name',
  'wallet.holding_pie': 'Holding pie',
  'wallet.holding_amount': 'Holding Qty. (EVAL Qty.)',
  'wallet.holding_amount_short': 'Holding Qty.',
  'wallet.deposit_and_withdraw': 'D/W',
  'wallet.total_cash': 'Total CASH',
  'wallet.on_trade_cash': 'Trade pending',
  'wallet.can_withdraw_cash': 'Withdrawal AVAIL',
  'wallet.accumulated_mining_coin': 'ACC. mining coin',
  'wallet.airdrop_lock': 'Airdrop(Lock)',
  'wallet.evaluated_cash': 'EVAL CASH',
  'wallet.cash_deposit': 'Deposit USDT',
  'wallet.cash_withdraw': 'Withdraw USDT',
  'wallet.deposit': 'Deposit',
  'wallet.withdraw': 'Withdraw',
  'wallet.cash_history': 'Cash trade history',
  'wallet.charge_with_bank_account': 'Charge A/C with cash',
  'wallet.charge_with_platform': 'Charge affiliate platform with cash',
  'wallet.charge_with_bank_account_desc':
    '※ After filling in the following deposit amount, click "request deposit" and then transfer the money on the same day (Before 24h).',
  'wallet.deposit_amount': 'deposit AMT',
  'wallet.deposit_amount_placeholder':
    'Please enter the amount you want to deposit',
  'wallet.won': 'Won',
  'wallet.request_deposit': 'Request deposit',
  'wallet.not_yet_verified':
    'ACCT verification is required to charge cash. Please proceed with account verification first.',
  'wallet.not_yet_verified_withdraw':
    'ACCT verification is required to withdraw cash. Please proceed with account verification first.',
  'wallet.cant_withdraw_now':
    'You cannot withdraw at this time. Please refer to the notice for details.',
  'wallet.request_verify_bank_account': 'Verify A/C',
  'wallet.select_platform': 'Choose affilate platform',
  'wallet.tmoney': 'T-Money',
  'wallet.okcashbag': 'OK cashbag',
  'wallet.shopcorn': 'SHC',
  'wallet.please_use_shopcorn':
    'The following platform is not prepared yet for charging cash. Please use SHC.',
  'wallet.go_to_charge_with_platform': 'Charge',
  'wallet.charge_with_platform_desc':
    '※ To charge cash, please go to affiliated site to chargeand send to exchange.',
  'wallet.are_you_going_to_shopcorn':
    'You can charge at www.shopcorn.co.kr. Will you charge now?',
  'wallet.oneday_withdraw_limit': 'Daily withdrawal limit',
  'wallet.min_withdraw_limit': 'Min. A/C withdrawal AVAIL',
  'wallet.onetime_withdraw_limit': 'One time withdrawal limit',
  'wallet.withdraw_to_bank_account': 'Bank account withdrawal',
  'wallet.withdraw_to_platform': 'Withdraw through affiliate platform',
  'wallet.can': 'AVAIL',
  'wallet.max': 'MAC',
  'wallet.request_withdraw_cash': 'Request CASH withdrawal',
  'wallet.can_use': 'AVAIL',
  'wallet.send_fee': 'Transfer fee',
  'wallet.please_enter_reciever_phone_num': "Enter payee's mobile",
  'wallet.platform_withdraw_alert':
    '※ If you are creating an account through affiliated company, your number needs to be same in order to withdraw.',
  'wallet.withdraw_bank_account_title': 'Withdrawal A/C INTRO',
  'wallet.bank_name': 'Bank name',
  'wallet.bank_account': 'A/C no.',
  'wallet.bank_account_holder': 'A/C holder',
  'wallet.check_otp': 'Check OTP',
  'wallet.hp_verification_for_your_safety':
    'For secure withdraw, please verify yourself once more through mobile.',
  'wallet.please_enter_verification_code': 'Enter VER. code',
  'wallet.get_verification_code': 'Receive VER. code',
  'wallet.check_verification_code': 'Check VER. code',
  'wallet.request_withdraw': 'Request withdrawal',
  'wallet.request_withdraw_short': 'Request withdrawal',
  'wallet.deposit_address': 'Deposit address',
  'wallet.deposit_withdraw_history': 'D/W history',
  'wallet.day': '{day}d',
  'wallet.1d': '1d',
  'wallet.7d': '7d',
  'wallet.30d': '30d',
  'wallet.60d': '60d',
  'wallet.all': 'All',
  'wallet.deposit_history': 'Deposit history',
  'wallet.withdraw_history': 'Withdrawal history',
  'wallet.depositWait_history': 'Pending deposit history',
  'wallet.airdrop_history': 'Payment history',
  'wallet.airdropLock_history': 'Airdrop(Lock) history',
  'wallet.wait': 'Wait',
  'wallet.complete': 'Complete',
  'wallet.request_date': 'Requested date',
  'wallet.deposit_name': 'Payee',
  'wallet.deposit_cash': 'Deposit USDT',
  'wallet.platform_address': 'Affiliated site/ A/C',
  'wallet.status': 'Status',
  'wallet.withdraw_date': 'Withdrawal date',
  'wallet.withdraw_request': 'Request withdrawal',
  'wallet.withdraw_complete': 'Withdraw completed',
  'wallet.fee': 'Fee',
  'wallet.reg_date': 'Registered date',
  'wallet.content': 'Content',
  'wallet.airdrop_cash': 'Paid USDT',
  'wallet.my_deposit_address':
    'my {coinName} deposit address(Only for deposit)',
  'wallet.new_member_must_create_address':
    'For new members, you need to click create address button to receive your personal number.',
  'wallet.deposit_alert': 'Deposit guideline',
  'wallet.you_can_check_last_deposit_withdraw_history_in_history_menu':
    '※ Past trade can be found at trade history..',
  'wallet.withdraw_fee_desc':
    'The withdrawal fee is 100 USDT per case. If you apply for 1,000 USDT, 100 USDT will be deducted and 900 USDT will be deposited into your registration account.',
  'wallet.copy': 'Copy',
  'wallet.withdraw_amount': 'AMT. withdrawn',
  'wallet.to_external_address': 'Send wallet to address',
  'wallet.to_internal_member': 'Send through mobile(Internal member)',
  'wallet.check_coin_address': 'Verify',
  'wallet.withdraw_fee': 'Withdrawal fee (VAT inc.)',
  'wallet.total_withdraw_amount': 'Total withdraw (VAT inc.)',
  'wallet.withdraw_alert': 'Withdrawal alert',
  'footer.link_about_company': 'Company INTRO',
  'footer.link_notice': 'Notice',
  'footer.link_terms': 'User agreement',
  'footer.link_privacy': 'Privacy policy',
  'footer.link_guide': 'Guide',
  'footer.link_faq': 'FAQ',
  'footer.copyright_line1':
    'CEO : Seo Jun, Min Business registration no. 678-88-00932 Telecommunication sale Report  : 2018-Seoul Gangnam-00897',
  'footer.copyright_line2':
    'Seoul, Gangnam-gu, Teheranro 14 Road 16 CBI Platform Co., Ltd.',
  'footer.cs_account': 'A/C. User guide',
  'footer.cs_pay': 'D/W, Other Inquiries',
  'footer.cs_time':
    'Customer Center Operation Hour : 09:30 ~ 17:30 (Lunch 12:00 ~ 13:00) Our company does not provide telephone or face to face customer service.',
  'footer.cs_kakaotalk': '24h Kakaotalk helpline',
  'account.find_id': 'Find ID',
  'account.find_pw': 'Find Password',
  'account.email': 'Email',
  'account.username': 'Username',
  'account.confirm': 'Confirm',
  'account.password': 'Password',
  'account.recommender': 'Recommender',
  'common.next': 'Next',
  'alert.please_enter_email': 'Type your email.',
  'alert.invalid_email': 'The email account is not valid.',
  'alert.please_enter_password': 'Type in your pw.',
  'uio_announce.yesterday_announcement': '1d Prior Notice',
  'uio_announce.original_mining': 'FXD AMT Mining Coin',
  'uio_announce.level_mining': 'Lv Mining Coin',
  'uio_announce.daterange_mining': 'Mining Coin Holding Period',

  'trade.iex_announce.platform_volume': 'Platform',
  'trade.iex_announce.partner_volume': 'Member액',
  'trade.iex_announce.holding_iex_amount': 'IEXCO held',
  'trade.iex_announce.total_mining_amount': 'My mining amount',
  'trade.iex_announce.total_iex_contribution_cash': 'My Contribution cash',
  'alert.market_comming_soon': '{market}Market is in preparation.',
  'alert.login_success': 'Nice to meet you. Welcome to UNIONEX.',
  'alert.login_failed': 'Login failed. please try again.',
  'alert.sended_findpw_email':
    'Temporary passwords and links have been sent by email. Please check your email.',
  'alert.api_error':
    'There was an error communicating with the server. please try again.',
  'findpw.title': 'Forgot your password',
  'findpw.info_message':
    'A temporary password will be sent to your registered email address.',
  'findpw.change_pw': 'Change Password',
  'signin.info_message':
    'To protect your valuable information, please make sure that the exchange address is the same as the address below.',
  'signup.agree_to_terms': 'Accept terms and conditions',
  'signup.agree_to_privacy_policy': 'Privacy policy agreement',
  'signup.please_agree_to_terms': 'Please agree to the terms and conditions.',
  'signup.please_agree_to_privacy_policy': 'Please agree to privacy policy.',
  'signup.alert.please_enter_email': 'Please enter your email address.',
  'signup.alert.invalid_email': 'Email format is incorrect.',
  'signup.alert.please_proceed_email_verification':
    'Please proceed to verify your email.',
  'signup.alert.please_enter_name': 'Input your name, please.',
  'signup.alert.please_enter_email_verification_code':
    'Please enter your email verification number.',
  'signup.alert.please_enter_password': 'Please enter a password.',
  'signup.alert.please_enter_password_check':
    'Please enter your password confirmation.',
  'signup.alert.pw_validation_length': 'Password must be at least 8 digits.',
  'signup.alert.pw_validation_combination':
    'Passwords must contain all alphanumeric characters and special characters.',
  'signup.alert.pw_and_pwcheck_not_same':
    'Password and password verification do not match.',
  'signup.alert.please_proceed_email_verification':
    'Please proceed to verify your email.',
  'signup.alert.please_check_google_recaptcha': 'Prove that it is not a robot.',
  'signup.alert.signup_success': 'Sign up is complete.',
  'signup.alert.please_check_email_verification_code':
    'Your email verification number has been sent. Please enter your verification number after confirmation.',
  'signup.alert.email_verification_time_expired':
    'Your email verification time has expired. Please request your email verification number and proceed with the verification process.',
  'signup.alert.email_verification_success':
    'Verification of your email verification number is complete.',
  'signup.alert.email_verification_code_is_not_matching':
    'The authentication number is incorrect. Please check again.',
  'wallet.history.request_date': 'Request date',
  'wallet.history.deposit_name': 'Depositor',
  'wallet.history.deposit_cash': 'Deposit USDT',
  'wallet.history.deposit_fiat': 'Deposit Amount',
  'wallet.history.account': 'Affiliate site / account',
  'wallet.history.status': 'Status',
  'wallet.history.withdraw_date': 'Withdrawal Date',
  'wallet.history.withdraw_request': 'Withdrawal request',
  'wallet.history.withdraw_is_complete': 'Withdrawal completed',
  'wallet.history.withdraw_fee': 'Fees',
  'wallet.history.withdraw_status': 'Status',
  'wallet.history.reg_date': 'Registration date',
  'wallet.history.content': 'Contents',
  'wallet.history.airdrop_cash': 'Paid USDT',
  'wallet.history.airdrop_coin': 'Paid Coin',
  'wallet.history.txid_link': 'Payment Cash',
  'wallet.history.amount': 'Qty.',
  'wallet.deposit_below_address':
    'Please deposit {coin_name} to the address below.',
  'wallet.generate_deposit_address': 'Create {coinName} address',
  'wallet.deposit_in_maintenance':
    'Deposit {coin_symbol} is currently being checked. Please use it in a moment.',
  'wallet.withdraw_from_exchange_wallet_to_your_wallet':
    'We will withdraw your {coin_name} from your exchange wallet to your external {coin_name} wallet. All withdrawals will be withdrawn after the administrator confirms.',
  'wallet.i_agree_to_withdraw_warning':
    'I have read and agree to the withdrawal instructions and notices.',
  'wallet.withdraw_address': 'Withdrawal address',
  'wallet.withdraw_under_maintanance':
    'Exits {coin_symbol} are currently being checked. Please use it in a moment.',
  'trade.market_under_maintance':
    ' Exits {market}market is currently being checked. Please use it in a moment.',
  'mypage.not_verified': 'Not verified',
  'mypage.verification_is_processing': 'Authentication in progress…',
  'mypage.refuse_verification': 'Authentication denied',
  'trade.alert.invalid_amount_price':
    'Please enter the order quantity and the order amount correctly.',
  'trade.alert.invalid_order_unit_price': 'call unit does not match.',
  'trade.alert.invalid_min_cash': 'Minimum orderable CASH is {cash}CASH.',
  'trade.alert.invalid_orderable_amount':
    'The orderable amount is insufficient.',
  'trade.alert.success_request_cancel_order':
    '미체결 주문 취소를 요청 하였습니다.',
  'mypage.verified': 'Verified',
  'mypage.kyc_verification': 'KYC Authentication',
  'mypage.kyc.verification_type': 'Type of identification',
  'mypage.kyc.passport': 'Passport',
  'mypage.kyc.id_card': 'ID Card',
  'mypage.kyc.driver_card': 'Drive card',
  'mypage.kyc.name': 'name',
  'mypage.kyc.first_name': 'First name',
  'mypage.kyc.last_name': 'Last name',
  'mypage.kyc.select': 'Select',
  'mypage.kyc.mobile_number': 'Mobile(Only Number)',
  'mypage.kyc.passport_number': 'Passport Number',
  'mypage.kyc.id_card_number': 'ID Number',
  'mypage.kyc.driver_card_number': 'Drive License Number',
  'mypage.kyc.region': 'Documents issued by country / region',
  'mypage.kyc.expire_date': 'Expiration Date',
  'mypage.kyc.issue_date': 'Issued Date',
  'mypage.kyc.upload_image': 'Upload',
  'mypage.kyc.upload': 'Upload',
  'mypage.kyc.modify': 'Modify',
  'mypage.kyc.delete': 'Delete',
  'mypage.kyc.country': 'Country',
  'mypage.kyc.city': 'City',
  'mypage.kyc.address': 'Address',
  'mypage.kyc.postcode': 'Postcode',
  'mypage.kyc.upload_image_example': 'Upload Image Example',
  'mypage.kyc.upload_image_example_description':
    'You can choose to upload the front of your Driver’s License or your National ID Doucument, together with a Note. Please provide a photo of you holding your Identity card. In the same picture, make a reference to “Maju.com” and today’s date displayed. Make sure your face is clearly visible and that all Identity card detail are clearly readable.',
  'mypage.kyc.ok': 'OK',
  'wallet.first_create_deposit_address':
    'Please create a coin wallet address in the deposit address tab and withdraw!',
  'mainbanner.buy': 'Buy',
  'mypage.kyc.please_upload_file_size_below_5mb':
    'Please upload your file size below 5MB.',

  "api_error_code.-3000": "There is not enough information.",
  "api_error_code.-3001": "Normal processing is not possible. Please contact your administrator.",
  "api_error_code.-3002": "Failed to load data.",
  "api_error_code.-3003": "Failed to send email. Please contact the administrator.",
  "api_error_code.-3005": "Your withdrawal request was not processed successfully. Please contact your administrator.",
  "api_error_code.-3006": "Login failed.",
  "api_error_code.-3007": "Failed to fetch data. Please contact your administrator.",
  "api_error_code.-3008": "Failed to update member information. Please contact your administrator.",
  "api_error_code.-3200": "Login is interrupted briefly due to a surge of access members.",
  "api_error_code.-3202": "Incorrect access.",
  "api_error_code.-3203": "You can use it after logging in.",
  "api_error_code.-3204": "Login blocked. Please contact us at {cs_tel}.",
  "api_error_code.-3300": "Prove that it is not a robot.",
  "api_error_code.-3301": "Prove that it is not a robot.",
  "api_error_code.-3400": "The authentication number is incorrect. Please check the authentication number.",
  "api_error_code.-3500": "QR code generation failed.",
  "api_error_code.-3501": "Failed to create Google Authenticator.",
  "api_error_code.-3502": "Google OTP update failed.",
  "api_error_code.-3503": "Failed to delete Google Authenticator.",
  "api_error_code.-3504": "There is no Google OTP history.",
  "api_error_code.-3505": "Failed to retrieve Google Authenticator information.",
  "api_error_code.-3506": "The Google OTP key does not match.",
  "api_error_code.-3507": "You can apply after creating Google Authenticator [LEVEL3].",
  "api_error_code.-3508": "Please enter your Google Authenticator code.",
  "api_error_code.-3600": "It is not accessible.",
  "api_error_code.-3601": "The expiration time has expired. Please request again.",
  "api_error_code.-3602": "Passwords do not match.",
  "api_error_code.-3702": "Invalid request.",
  "api_error_code.-3703": "Failed to send email.",
  "api_error_code.-3800": "Registered member does not exist.",
  "api_error_code.-3801": "Registered member.",
  "api_error_code.-3802": "Membership failed.",
  "api_error_code.-3803": "member information does not match.",
  "api_error_code.-3804": "Passwords do not match.",
  "api_error_code.-3805": "Member company information does not match.",
  "api_error_code.-3806": "Failed to update member information.",
  "api_error_code.-3807": "The wallet does not exist.",
  "api_error_code.-3808": "Account registration failed.",
  "api_error_code.-3809": "Account verification failed.",
  "api_error_code.-3810": "Waiting for administrator approval.",
  "api_error_code.-3811": "Already admin approved",
  "api_error_code.-3812": "Failed to raise the withdrawal limit. Please contact your administrator.",
  "api_error_code.-3813": "Please complete email verification.",
  "api_error_code.-3900": "Please proceed with KYC certification.",
  "api_error_code.-3901": "Waiting for authentication now.",
  "api_error_code.-3902": "Failed to apply for KYC certification.",
  "api_error_code.-3903": "Please register your image.",
  "api_error_code.-3904": "Only image files of less than 5M can be uploaded.",
  "api_error_code.-3905": "File upload failed.",
  "api_error_code.-4000": "Invalid request.",
  "api_error_code.-4001": "Invalid request.",
  "api_error_code.-4002": "Invalid request.",
  "api_error_code.-4003": "Up to 20 waiting orders can be placed.",
  "api_error_code.-4004": "The minimum order amount is {price} {market}.",
  "api_error_code.-4005": "The Price Unit is {priceUnit}. Please check the Price Unit again.",
  "api_error_code.-4006": "The minimum order quantity is {amount} {symbol}.",
  "api_error_code.-4007": "자산이 부족합니다.",
  "api_error_code.-4008": "자산이 부족합니다.",
  "api_error_code.-4009": "Your order has failed. Please contact your administrator.",
  "api_error_code.-4010": "Your order has failed. Please contact your administrator.",
  "api_error_code.-4011": "Order price is limited to 50% of market price",
  "api_error_code.-4012": "Order price is limited to 50% of market price",
  "api_error_code.-4013": "Invalid market request.",
  "api_error_code.-4014": "Market is paused.",
  "api_error_code.-4016": "Temporary buying stopped.",
  "api_error_code.-4017": "Temporary selling stopped.",
  "api_error_code.-4018": "Invalid request.",
  "api_error_code.-4019": "The contract has already been completed.",
  "api_error_code.-4020": "Your order has already been canceled.",
  "api_error_code.-4021": "Your order cancellation was not successful. Please contact the administrator.",
  "api_error_code.-4022": "Your order cancellation was not successful. Please contact the administrator.",
  "api_error_code.-4023": "Cancel processing is currently in progress.",
  "api_error_code.-4024": "The contract is currently in progress.",
  "api_error_code.-4025": "The minimum purchase price of {symbol} is {price}{market}.",
  "api_error_code.-4026": "The minimum selling price of {symbol} is {price}{market}.",
  "api_error_code.-4100": "Please try again because the exchange rate has changed.",
  "api_error_code.-4101": "Invalid request.",
  "api_error_code.-4102": "Invalid request.",
  "api_error_code.-4103": "You can withdraw after 72 hours after your first deposit.",
  "api_error_code.-4104": "The minimum deposit is less than 10,000 USDT.",
  "api_error_code.-4105": "There is a deposit record of the same amount as the current request. Requests for same amount of money can be applied after 24 hours.",
  "api_error_code.-4106": "Failed to register deposit request.",
  "api_error_code.-4107": "The withdrawal was temporarily restricted. Please contact the administrator.",
  "api_error_code.-4108": "Wallet is temporarily unavailable.",
  "api_error_code.-4109": "Log information is not registered.",
  "api_error_code.-4110": "Please check the minimum withdrawal amount.",
  "api_error_code.-4111": "Please confirm the maximum withdrawal amount once.",
  "api_error_code.-4112": "Please confirm the maximum withdrawal amount per day.",
  "api_error_code.-4113": "There is not enough balance.",
  "api_error_code.-4114": "The withdrawal application failed. Please try again later.",
  "api_error_code.-4115": "Failed to withdraw. Please contact your administrator.",
  "api_error_code.-4116": "You can not transfer to your wallet address.",
  "api_error_code.-4117": "The maximum amount you can withdraw at once is {amount} {symbol}.",
  "api_error_code.-4118": "The minimum order quantity is {amount} {symbol}.",
  "api_error_code.-4119": "It's not the right address.",
  "api_error_code.-4120": "Please proceed with KYC certification.",
  "api_error_code.-4121": "You can apply for a withdrawal after registering a withdrawal account.",
  "api_error_code.-4122": "Invalid request.",
  "api_error_code.-4123": "We stop creating wallets for company reasons.",
  "api_error_code.-4124": "Wallet creation failed.",
  "api_error_code.-4125": "Wallet creation failed.",
  "api_error_code.-4126": "Wallet is temporarily unavailable.",
  "api_error_code.-4127": "The withdrawal has been temporarily disabled.",
  "api_error_code.-4128": "Failed to load data.",
  "api_error_code.-4129": "Failed to get exchange information.",
  "api_error_code.-4130": "Failed to load data.",
  "api_error_code.-4131": "Address check failed. Please contact your administrator.",
  "api_error_code.-4132": "This is not a convertible coin.",
  "api_error_code.-4133": "Invalid request",
  "api_error_code.-4134": "The minimum conversion quantity is 1USDT.",
  "api_error_code.-4135": "There are not enough convertible coins.",
  "api_error_code.-4136": "Failed to register conversion request. Please contact your administrator.",
  "api_error_code.-4137": "Failed to register conversion request. Please contact your administrator.",
  "api_error_code.-4138": "Failed to register conversion request. Please contact your administrator.",
  "api_error_code.-4139": "Please try after creating the wallet.",
  "api_error_code.-4200": "Failed to retrieve asset information. Please contact your administrator.",
  "api_error_code.-4300": "",
  "api_error_code.-4301": "",
  "api_error_code.-4302": "",
  "api_error_code.-4303": "",
  "api_error_code.-4304": "",
  "api_error_code.-4305": "",
  "api_error_code.-4306": "",
  "api_error_code.-4307": "",
  "api_error_code.-4308": "",
  "api_error_code.-4309": "",
  "api_error_code.-4310": "",
  "api_error_code.-4311": "",
  "api_error_code.-4312": "",
  "api_error_code.-4313": "",

  'kyc.complete_message':
    'KYC certification application is completed.<br />It takes 2 ~ 4 days to complete KYC certification.<br />Once the authentication is complete, you can check it in the<br />Authentication Center.<br/>Thank you.',
  'alert.change_password_completed':
    'Password change has been completed. Please login with new password.',
  'alert.please_enter_temp_password': 'Please enter temp password.',
  'mypage.temp_password': 'Temp password',
  'alert.otp_check_completed': 'OTP verification completed.',
  'alert.withdraw_request_is_completed':
    'The request to withdraw has been completed.',
  'trade.alert.not_match_amount_and_price':
    'Please enter correct order quantity and amount.',
  'trade.alert.not_match_unit_price': 'Unit price do not match. Unit price is {unitPrice}.',
  'trade.alert.min_orderable_cash_error':
    'Minimum orderable {market_type} is {min_orderable_cash}{market_type}.',
  'trade.alert.max_orderable_cash_error':
    'Maximum orderable {market_type} is {max_orderable_cash}{market_type}.',
  'trade.alert.run_out_of_cash': 'The orderable amount is insufficient.',
  'trade.alert.market_is_under_maintenance':
    'The market {market} is currently being maintanance. Please retry in a few minutes.',
  'trade.confirm_order': 'Confirm Order',
  'alert.market_is_preparing': '{market} Market is preparing.',
  'alert.cancel_order_completed': 'The order you requested has been canceled.',
  'alert.cancel_order_requested':
    'You have requested cancellation of your outstanding order.',
  'alert.withdraw_request_is_completed':
    'The withdrawal request has been completed.',
  'alert.please_enter_address_to_check': 'Enter the address you want to check.',
  'alert.checking_address_is_completed':
    'Confirmation of withdrawal address is complete.',
  'alert.please_deposit_cash':
    'The request for cash deposit has been completed. Please deposit it into the account.',
  'wallet.please_deposit_cash_desc':
    'Please deposit <span class="deposit-money">{deposit_amount}</span> {currency} you requested for deposit into the account below',
  'wallet.deposit_warning_title': 'Notes on Deposit Request',
  'wallet.deposit_warning_li1':
    'You must deposit the money within midnight of the day after applying for deposit.',
  'wallet.deposit_warning_li2':
    'If you make a deposit past 24 hours of the day, you will need to add a new deposit request for that date.',
  'wallet.deposit_warning_li3':
    'You cannot apply for the same amount twice in a row.',
  'wallet.deposit_warning_li4':
    'Please check your deposit account number and bank and make a deposit.',
  'mypage.otp_activate': 'Activate OTP',
  'mypage.i_check_about_otp': 'I checked.',
  'mypage.otp_warning_li1':
    'Please scan the left QR code with your mobile phone.',
  'mypage.otp_warning_li2': 'This code will change when OTP is initialized.',
  'mypage.otp_warning_li3':
    'Not available if you delete this QR code from your mobile phone',
  'mypage.alert.otp_warning_check': 'Please read and check the precautions.',
  'mypage.alert.otp_activation_completed': 'OTP setup completed.',
  'wallet.deposit_account_registration': 'Deposit account registration',
  'mypage.complete_registration_deposit_account':
    'Deposit account registration has been completed.',
  'alert.otp_delete_completed': 'Disabling OTP settings has been completed.',
  'alert.otp_setting_updated': 'OTP settings have been updated.',
  'signup.alert.password_change_completed':
    'Password has been changed successfully.',
  'signup.alert.password_change_failed': 'Password change failed.',
  'signin.please_enter_otp_6':
    'Please enter 6 digits of OTP authentication number.',
  'alert.deposit_address_copied': 'The deposit address has been copied.',
  'mypage.cryptocurrency': 'Cryptocurrency',
  'mypage.authentication_type': 'Authentication Type',
  'mypage.deposit_limit': 'Deposit limit',
  'mypage.withdrawal_limit': 'Withdrawal limit',
  'mypage.unlimited': 'Unlimited',
  'mypage.once': 'Once',
  'mypage.by_oneday': 'One day',
  'guide.main_title': 'User’s Guide',
  'guide.platform_title': 'Platform Guide',
  'guide.trade_title': 'D/W Guide',
  'guide.cash_market': 'USDT Markets',
  'guide.market_gubun': 'Market Type',
  'guide.gubun': 'Type',
  'guide.content': 'Contents',
  'guide.cash_market': 'USDT Markets',
  'guide.cash_market_desc': 'USDT is used to buy or sell cryptocurrencies.',
  'guide.day_trade_data_standard': 'Standard for daily transaction data',
  'guide.day_trade_data_standard_desc':
    'Daily data is calculated in reference to the GMT/UTC. As most of the global exchanges us the GMT/UTC as their reference time, it allows the prices to be easily compared with those provided by overseas markets. Local time in Seoul, Korea is 9 hours ahead of the GMT/UTC.',
  'guide.updown_yesterday': 'Net change',
  'guide.updown_yesterday_desc':
    'the difference between the prior day’s closing price and the current day’s closing price (or current price) with reference to 00:00 GMT/UTC.',
  'guide.trade_volume': 'Transaction volume (24H)',
  'guide.trade_volume_desc':
    'cumulative transaction volume during the last 24 hours',
  'guide.candle_day': 'Candlestick on the candlestick chart',
  'guide.candle_day_desc':
    'opening/high/low/closing prices during 24 hours from 00:00 till 24:00 with reference to GMT/UTC',
  'guide.trade_fee_standard': 'Standard for transaction fees',
  'guide.trade_fee_standard_desc1':
    'Transaction fee calculation method: Closing amount (order quantity X order price) X rate of the transaction fee (%)',
  'guide.trade_fee_standard_desc2':
    'Transaction fees are displayed up to the second decimal place.',
  'guide.trade_fee_method': 'Calculation method for transaction fees',
  'guide.trade_fee_method_desc1':
    'Calculated amount for buying orders = Closing amount (order quantity X order price) + rate of the transaction fee',
  'guide.trade_fee_method_desc2':
    'Calculated amount for selling orders = Closing amount (order quantity X order price) - rate of the transaction fee',
  'guide.min_orderable_price_and_unit_price':
    'Minimum ordering unit and Minimum asking price unit',
  'guide.min_orderable_price_and_unit_price': 'Minimum ordering unit',
  'guide.unit_price': 'Minimum asking price unit',
  'guide.deposit_fee': 'Deposit fee',
  'guide.withdrawal_fee': 'Withdrawal fee',
  'guide.no_charge': 'No charge',
  'guide.dw_support_title': 'Currencies available for deposits/withdrawals',
  'guide.level_guide_title':
    'Daily limits on deposits/withdrawals according to security level',
  'guide.dw_fee_guide_title': 'Deposit/withdrawal fees (including VAT)',
  'guide.dw_fee_guide_desc1':
    'After converting to CASH, it is available for exchange or use on the platform.',
  'guide.dw_fee_guide_desc2':
    'This is to inform you that the above fee policy may subject to change without prior notice in accordance with Section 25 of the Terms of Use.',
  'guide.unionex_mining_title': 'Mining according to transaction amount',
  'guide.mining_range': 'Mining section',
  'guide.mining_coin_cnt': 'Number of issued coins',
  'guide.mining_volume': 'Transaction amount (USDT)',
  'socket_api_code.202': '{od_temp_coin} {currency} Sell Orders Completed',
  'socket_api_code.204': '{od_temp_coin} {currency} BUY Order Complete',
  'socket_api_code.206': '{currency} sell order canceled.',
  'socket_api_code.208': 'Your {currency} purchase order has been canceled.',
  'socket_api_code.210': '{currency} {od_temp_coin} orders contracted.',
  'otp.remove': 'Remove',
  'otp.verification_pending': 'Pending...',
  'home.m.title': 'Services Optimized for Mobile Transactions',
  'home.m.desc':
    'It provides mobile user interface that enables cryptocurrency transactions anytime, anywhere.',
  'home.about.t1': "Best Security Sysetm",
  'home.about.d1': `<li>A complete security system for hacking</li>
    <li>Coldwalt Storage System</li>
    <li>24-hours coin deposit withdrawal monitoring system</li>`,
  'home.about.t2': 'Share Economy Platform',
  'home.about.d2': `<li>The revenue from the platform(transaction fees) is shared with partners and users.</li>
    <li>Keep in touch with partnets and users.</li>`,
  'home.about.t3': 'Platform of Independent Technology',
  'home.about.d3':
    `<li>Have years of operational know-how</li>
  <li>It is a platform that has been developed with its own technical skills.</li>`,
  'home.about.t4': 'Trusted Management and Practice ',
  'home.about.d4':
    `<li>Separate ownership from management</li>
    <li>Disclosure of all management data.</li>`,
  'security.your_level.lv1':
    'Your current membership is LV1. You can use the trading floor right away. Please activate the coin withdrawal and verifying yourself at the next step ‘KYC authentication.’',
  'security.your_level.lv2':
    'Your current membership is LV2. Identity verification has been completed. You can tighten up security through OTP authentication at the next step and deposit and withdraw more coins.',
  'security.your_level.lv3':
    'Your current membership is LV3.',
  'security.your_level.lv4':
    'Your current membership is LV4. The requirement to raise withdrawal limit has been completed.',
  'security.level4.desc':
    'If you request a withdrawal limit increase, the manager raises the level according to your transaction performance and contribution.',
  'security.level4.request': 'Request to increase the withdrawal limit',
  'security.level4.pending': 'Processing...',
  'security.level4.desc_success':
    'Your requirement to raise withdrawal limit has been approved.',
  'security.level4.desc_failed':
    'Your requirement to raise withdrawal limit has been rejected. It requires more trading performance.',
  'alert.request_lv4_success':
    'Successful withdrawal limit request. Please wait for admin confirmation.',
  'coinInfo.summary': 'Summary',
  'coinInfo.about': 'About this coin',
  'alert.bank_verification.no_kyc': 'It can be used after KYC authentication.',
  'alert.do_you_want_to_log_out': 'Do you want to logout?',
  'wallet.minimum_withdraw_amount': 'Minimum withdrawal amount',
  'wallet.withdraw_account_info': 'Withdrawal account information',
  'trade.favorite': 'Favorites',
  required: 'Required',
  all_is_required: 'All fields are required.',
  txid: 'txid',
  'alert.you_can_search_max_three_month': 'You can view up to 3 months.',
  'trade.hours': 'Hours',
  'myinvest.you_have_no_coin': 'You have no coin.',
  'wallet.history.od_status.CAN': 'Cancelled',
  'wallet.history.od_status.OK': 'Completed',
  'wallet.history.od_status.REQ': 'Requested',
  'wallet.history.od_status.WAIT': 'Pending',
  'wallet.history.od_status.REJ': 'Rejected',
  'wallet.history.od_status.HOLD': 'Hold',
  'wallet.history.od_status.PROC': 'Processing',
  'alert.please_verify_otp_code': 'Please verify OTP Code.',
  'alert.min_deposit_up_is': '※ Minimum deposit amount is {min_deposit}USDT.',
  'alert.min_deposit_usdt': 'Minimum deposit USDT',
  'notice.hq': 'Full notice',
  'bankaccount.desc': 'Withdrawal account can register only one account of his / her own name regardless of bank.',
  'wallet.convert': 'Convert',
  'wallet.convert_coin': 'Convert coin',
  'wallet.convert_history': 'Conversion history',
  'wallet.convertable_coin': 'Convertible Coins',
  'wallet.lets_convert_coin': 'Convert to Coin USDT Coin',
  'wallet.alert.only_btc_and_eth_is_convertable': '※ Only BTC and ETH coins can be converted to USDT coins.',
  'wallet.convert_amount': 'Conversion volume',
  'wallet.usdt_amount': 'USDT Quantity',
  'wallet.select_coin': 'Select coin',
  'wallet.request_convert': 'Convert',
  'wallet.check_below_before_convert_usdt': 'Do you want to convert coins as below?',
  'wallet.coin_convert_done': 'Coin conversion is completed.',
  'alert.first_login': 'Pre-registration is complete. "8,000 USDT" for mock investments can be found by logging in during the competition.',
  'kyc.rejected': 'KYC certification was rejected. Please proceed again!',
  'trade.today_volume': 'Today volume',
  'trade.yesterday_volume': 'Yesterday volume',
  'kyc.rejected_type_0': 'KYC certification was rejected. Please proceed again!',
  'kyc.rejected_type_1': 'Please post a picture of me with your ID card in your hand.',
  'kyc.rejected_type_2': 'Unable to verify the contents of your ID card.',
  'kyc.rejected_type_3': 'Please enter your first name separately by separating your last name from your last name.',
  'kyc.rejected_type_4': 'Etc -Please contact customer service!',
  'kyc.rejected_type_5': '메모 내용이 누락되었거나 정확하지 않습니다. (내용 : URL, 오늘 날짜)',
  'kyc.check_rejected_msg': '거절사유 보기',
  'wallet.history.airdrop_date': 'Date of Payment',
  'wallet.history.airdrop_type': 'Division',
  'wallet.history.airdrop_amount': 'Quantity of Payment (LOCK)',
  'wallet.history.airdrop_release_lock': 'Release Start',
  'wallet.history.airdrop_release_lock_period': 'Release Cycle',
  'wallet.history.airdrop_release_lock_amount': 'Release Quantity',
  'wallet.history.is_mining': 'Mining',
  'wallet.alert.convert_price_is_on_cmc': '※ The base price for USDT conversion is based on CoinMarketCap.',
  'home.about.guide.platform.title': "Operations Policy",
  'home.about.guide.platform.desc': `<li>A general outline</li>
  <li>UNIEX Platform coin</li>
  <li>Distribution of profits</li>
  <li>User's deposit withdrawal procedure</li>
  <li>Deposit withdrawal support limits for deposits by security grade of money and users.</li>`,
  'home.about.guide.trade.title': "Information on the use of coin transactions",
  'home.about.guide.trade.desc': `<li>Market classification</li>
  <li>Criteria for Daily Transaction Data</li>
  <li>Criteria for calculation and settlement of fees</li>
  <li>Minumum Order unit and Price Unit</li>
  <li>Coin deposit withdrawal fee</li>`,
  'home.about.guide.download.title': "Download",
  'home.about.guide.download.warning_for_investor': "Investor Precautions",
  'home.about.guide.download.fraud_guide': "A financial fraud guide",
  'home.about.guide.download.deposit_error': "Handling coin deposit errors",
  'wallet.withdraw_dest_tag': 'Destination Tag',
  'wallet.my_deposit_dest_tag': 'My Destination Tag',
  'alert.deposit_dest_tag_copied': 'Destination tag is copied.',
  'wallet.staking_history': 'Staking History',
  'wallet.history.coin_amount': "Coin Amount",
  'wallet.history.release_staking_date': "De-staking Date",
  'wallet.history.release_staking_start_date': "Staking Date",
  'wallet.history.release_staking_end_date': "De-staking Date",
  'mypage.cancel_account': 'Close my account',
  'mypage.cancel_account.step1.title': 'Notice of close my account',
  'mypage.cancel_account.step1.desc': 'Read the notice of close my account',
  'mypage.cancel_account.step2.title': 'Check the assets held',
  'mypage.cancel_account.step2.desc': 'Check your assets. Make a withdrawal',
  'mypage.cancel_account.step3.title': 'An application form for close my account',
  'mypage.cancel_account.step3.desc': 'Fill out an application form and submit it',
  'mypage.cancel_account.step4.title': 'Complete application',
  'mypage.cancel_account.step4.desc': 'Close my account application has been completed',
  'mypage.cancel_account.step1.body_title': 'Notice of close my account',
  'mypage.cancel_account.step1.body_desc': '1. Checking the assets held<br />2. Withdraw the remaining assets.<br />3. All personal information and asset is lost and not recovered.<br />4. Re-confirm everything before closing the my account',
  'mypage.cancel_account.step2.body_title': 'Check please the assets held',
  'mypage.cancel_account.step2.body_desc': '1. Be sure to check your assets.<br />2. Please close my account after withdrawal.<br />3. It will not be recovered after close my account.',
  'mypage.cancel_account.step3.body_title': 'An application form for close my account',
  'mypage.cancel_account.step3.body_desc': '[ Be careful when filling out an application ]<br />1. Choose between ID card, driver\'s license or passport. 2. Take an ID and take a picture as shown in the example.<br />3. You need to be able to check your face and ID.',
  'mypage.cancel_account.step4.body_title': 'Complete application form for close my account',
  'mypage.cancel_account.step4.body_desc': 'The processing period is about 2 to 3 days.<br />Thank you for using it.',
  'mypage.cancel_account.next': 'Next',
  'mypage.cancel_account.go_to_write_form': 'Application form',
  'mypage.cancel_account.ok': 'OK',
  'mypage.cancel_account.please_write_form_first': 'Please write application form first.',
};
